import BaseModel from "models/base.model";
import { isArray } from "utils/checking.util";

export default class FinancialRep extends BaseModel {
    static endpoint = "financial_reps.json";

    id; // The unique id of the record in the database
    firstName; // Their first name
    lastName; // Their last name
    middleName; // Their middle name
    title; // Their job title
    distance; // How far they are from the input search query
    street; // Their street address
    building; // Their building info (suite #)
    city; // What city they're in
    state; // The state they're in
    zip; // Their zip code
    zipLastFour; // The last four digits of their zip code
    address; // The address they searched for
    addressTypes; // The type of address returned by google geocoding
    latitude;
    longitude;
    photo; // A URL to their profile image
    languages; // An array of the languages that they speak outside of english
    briefBio;
    socialNetworks;
    areasOfExpertise;
    gender;
    slug; //unique path identifier for each person; combination of first, middle, last name
    _phoneNumbers;
    _designations;

    // Computed accessor to generate the user's fullname
    get fullName() {
        let fullName = [];
        if (this.firstName) {
            fullName.push(this.firstName);
        }

        if (this.middleName) {
            fullName.push(this.middleName);
        }

        if (this.lastName) {
            fullName.push(this.lastName);
        }

        return fullName.join(" ");
    }

    // Computed accessor to generate a formatted distance
    get formattedDistance() {
        return this.distance.toFixed(1);
    }

    // Computed accessor to generate a formatted address
    get formattedAddress() {
        let addressPieces = [];

        if (this.street) addressPieces.push(this.street);
        if (this.building) addressPieces.push(this.building);

        addressPieces.push("\n" + this.city + ", " + this.state);

        if (this.zipLastFour) {
            addressPieces.push(this.zip + "-" + this.zipLastFour);
        } else {
            addressPieces.push(this.zip);
        }

        return addressPieces.join(" ");
    }

    get standardizedTitle() {
        if(this.type === 'MD') {
            return "Managing Director";
        }

        return this.title;
    }

    get designations() {
        if (!isArray(this._designations)) {
            return [];
        }

        return this._designations;
    }

    set designations(value) {
        if (!isArray(value)) {
            value = [];
        }

        this._designations = value;
    }

    get phoneNumbers() {
        if (!isArray(this._phoneNumbers)) {
            return [];
        }

        return this._phoneNumbers;
    }

    set phoneNumbers(value) {
        if (!isArray(value)) {
            value = [];
        }

        this._phoneNumbers = value;
    }
}
